import { MEASURE_NAMES, MEASURE_SCORES } from '../../constants/assessments';
import { GRADE } from '../../constants/enrollment';
import { D8_INTERPRETATIONS } from '../../constants/interpretations';

export const INTERPRETATIONS_AT_RISK = [
    D8_INTERPRETATIONS.WELL_BELOW_BENCHMARK,
    D8_INTERPRETATIONS.BELOW_BENCHMARK,
];

export const COMPLETED_RESULT_INTERPRETATIONS = [
    D8_INTERPRETATIONS.ABOVE_BENCHMARK,
    D8_INTERPRETATIONS.AT_BENCHMARK,
    D8_INTERPRETATIONS.BELOW_BENCHMARK,
    D8_INTERPRETATIONS.WELL_BELOW_BENCHMARK,
];

export const GATING_RULES_AT_RISK = ['DISCONTINUE'];

/**
 * Set of recommendation rules.
 * Algorithm rely on rules order.
 *
 * =============== DEFINITION OF CONCEPTS ======
 * At-risk - student's skill scored with yellow/red
 * interpretation or discontinued imputed score.
 *
 * =============== EXAMPLE =====================
 * Administration rules for K grade:
 *  - LNF;
 *  - PSF;
 *  - WRF;
 *  - NWF;
 *
 * There are several rules for K grade:
 *  - if at-risk on one measure, PM with that measure unless it is LNF;
 *  - if at-risk on LNF only, no recommendation
 *  - if at-risk on LNF and another measure, PM with the other measure
 *  - if at-risk on WRF and another measure, PM with the other measure
 *  - when there is an option that is not LNF or WRF, use that other measure
 *  - if at-risk on NWF (CLS) + anything else, PM with NWF (CLS)
 *
 * For this set recommendations are:
 *  - if we have results at-risk on NWF we should use NWF as
 *  recommended measure and do not take into account results
 *  at-risk on other measures.
 *  - if we have results at-risk on LNF, WRF and PSF or LNF and PSF
 *  or WRF and PSF or common PSF (without NWF) - recommended measure
 *  is PSF;
 *  - if we have common result at-risk on WRF (without PSF
 *  or NWF) - recommended measure is WRF;
 */
export default {
    [GRADE.KG]: [
        {
            atRisk: [MEASURE_SCORES.NWF_CLS],
            recommendedMeasures: [MEASURE_NAMES.NWF],
        },
        {
            atRisk: [MEASURE_SCORES.PSF],
            recommendedMeasures: [MEASURE_NAMES.PSF],
        },
        {
            atRisk: [MEASURE_SCORES.WRF],
            recommendedMeasures: [MEASURE_NAMES.WRF],
        },
    ],
    [GRADE.ONE]: [
        {
            atRisk: [MEASURE_SCORES.NWF_CLS],
            recommendedMeasures: [MEASURE_NAMES.NWF],
        },
        {
            atRisk: [MEASURE_SCORES.PSF, MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.PSF, MEASURE_NAMES.ORF],
        },
        {
            atRisk: [MEASURE_SCORES.PSF],
            recommendedMeasures: [MEASURE_NAMES.PSF],
        },
        {
            atRisk: [MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.ORF],
        },
        {
            atRisk: [MEASURE_SCORES.WRF],
            recommendedMeasures: [MEASURE_NAMES.WRF],
        },
    ],
    [GRADE.TWO]: [
        {
            atRisk: [MEASURE_SCORES.WRF, MEASURE_SCORES.NWF_CLS, MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.WRF, MEASURE_NAMES.NWF, MEASURE_NAMES.ORF],
        },
        {
            atRisk: [MEASURE_SCORES.WRF, MEASURE_SCORES.NWF_CLS],
            recommendedMeasures: [MEASURE_NAMES.WRF, MEASURE_NAMES.NWF],
        },
        {
            atRisk: [MEASURE_SCORES.ORF, MEASURE_SCORES.WRF],
            recommendedMeasures: [MEASURE_NAMES.ORF, MEASURE_NAMES.WRF],
        },
        {
            atRisk: [MEASURE_SCORES.NWF_CLS],
            recommendedMeasures: [MEASURE_NAMES.NWF],
        },
        {
            atRisk: [MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.ORF],
        },
        {
            atRisk: [MEASURE_SCORES.WRF],
            recommendedMeasures: [MEASURE_NAMES.WRF],
        },
    ],
    [GRADE.THREE]: [
        {
            atRisk: [MEASURE_SCORES.WRF, MEASURE_SCORES.NWF_CLS, MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.WRF, MEASURE_NAMES.NWF, MEASURE_NAMES.ORF],
        },
        {
            atRisk: [MEASURE_SCORES.WRF, MEASURE_SCORES.NWF_CLS],
            recommendedMeasures: [MEASURE_NAMES.WRF, MEASURE_NAMES.NWF],
        },
        {
            atRisk: [MEASURE_SCORES.ORF, MEASURE_SCORES.WRF],
            recommendedMeasures: [MEASURE_NAMES.ORF, MEASURE_NAMES.WRF],
        },
        {
            atRisk: [MEASURE_SCORES.NWF_CLS],
            recommendedMeasures: [MEASURE_NAMES.NWF],
        },
        {
            atRisk: [MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.ORF],
        },
        {
            atRisk: [MEASURE_SCORES.WRF],
            recommendedMeasures: [MEASURE_NAMES.WRF],
        },
    ],
    [GRADE.FOUR]: [
        {
            atRisk: [MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.ORF],
        },
    ],
    [GRADE.FIVE]: [
        {
            atRisk: [MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.ORF],
        },
    ],
    [GRADE.SIX]: [
        {
            atRisk: [MEASURE_SCORES.ORF],
            recommendedMeasures: [MEASURE_NAMES.ORF],
        },
    ],
};
